module.exports = __webpack_public_path__ + "static/img/OC_bg06.8cd8fbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/form/runtime/components/assets/OC_bg06.png
// module id = a9PY
// module chunks = 7